import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gob-next-festival',
  templateUrl: './next-festival.component.html',
  styleUrls: ['./next-festival.component.scss']
})
export class NextFestivalComponent implements OnInit {
  
  titrePrincipal: string = 'BylesJeuxDuStan';
  sousTitre: string = 'Votre destination pour les jeux de société modernes et les évènements ludiques';

  constructor() {}

  ngOnInit(): void {
  }
}